import React, { useState, useEffect, useContext } from "react";
import { toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import axiosInstance from "api/axiosInstance";
import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDInput from "components/MDInput";
import MDButton from "components/MDButton";
import { IconButton, InputAdornment, Icon } from "@mui/material";
import BasicLayout from "layouts/authentication/components/BasicLayout";
import bgImage from "assets/images/bg-profile.jpeg"; // Use a different background
import CircularProgress from "@mui/material/CircularProgress";
import { LanguageContext } from "../../../context/LanguageContext";

export default function AdminLogin() {
  const [status, setStatus] = useState({ loading: false, message: "", error: false });
  const [formData, setFormData] = useState({ email: "", password: "" });
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();
  
  const { componentLanguageData, loadLanguageFile, language } = useContext(LanguageContext);
  useEffect(() => {
    loadLanguageFile("signin", "authentication/sign-in/sign-in_lang");
  }, [language]);
  
  const LANGUAGE = componentLanguageData.signin || { Main: {}, Error: {}, Alert: {} };

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleLogin = async (e) => {
    e.preventDefault();
    setStatus({ loading: true, message: "", error: false });
    
    try {
      localStorage.setItem("pendingVerifyEmail", formData.email);
      localStorage.setItem("loginSource", "ADMIN");
      // 🔥 使用管理員專用登入 API
      const res = await axiosInstance.post("/auth/admin/login", formData);
      // 修補 C3b/H6：存 pending token 供第二階段 verify-token 驗證
      localStorage.setItem("pendingToken", res.data?.pendingToken || "");
      toast.success("管理員身份驗證成功，請進行二次驗證");
      navigate("/authentication/2fa");
    } catch (error) {
      const errorMsg = error.response?.data?.message || "登入失敗";
      toast.error(errorMsg);
      setStatus({ loading: false, message: "", error: false });
    }
  };

  return (
    <BasicLayout image={bgImage}>
      <Card sx={{ backgroundColor: "rgba(30, 30, 30, 0.9)", color: "white" }}>
        <MDBox pt={4} pb={3} px={3}>
          <MDBox display="flex" flexDirection="column" alignItems="center" mb={3}>
             <MDBox
                component="img"
                src="/images/logo/logo_2.png"
                alt="Logo"
                width="120px"
                mb={2}
                sx={{ filter: "brightness(0) invert(1)" }}
              />
            <MDTypography variant="h4" fontWeight="medium" color="white" gutterBottom>
              Admin Portal
            </MDTypography>
            <MDTypography variant="button" color="white" fontWeight="light">
              System Management Access Only
            </MDTypography>
          </MDBox>
          <MDBox component="form" role="form" onSubmit={handleLogin}>
            <MDBox mb={2}>
              <MDInput
                type="email"
                name="email"
                label="Administrator Email"
                fullWidth
                value={formData.email}
                onChange={handleChange}
                sx={{ input: { color: "white" }, label: { color: "rgba(255,255,255,0.7)" } }}
              />
            </MDBox>
            <MDBox mb={2}>
              <MDInput
                type={showPassword ? "text" : "password"}
                name="password"
                label="Security Key"
                fullWidth
                value={formData.password}
                onChange={handleChange}
                sx={{ input: { color: "white" }, label: { color: "rgba(255,255,255,0.7)" } }}
                InputProps={
                  formData.password.length > 0
                    ? {
                        endAdornment: (
                          <InputAdornment position="end">
                            <IconButton onClick={() => setShowPassword((v) => !v)} edge="end" size="small" aria-label="toggle password visibility" tabIndex={-1} sx={{ color: "rgba(255,255,255,0.7)" }}>
                              <Icon fontSize="small">{showPassword ? "visibility" : "visibility_off"}</Icon>
                            </IconButton>
                          </InputAdornment>
                        ),
                      }
                    : undefined
                }
              />
            </MDBox>
            <MDBox mt={4} mb={1}>
              <MDButton type="submit" variant="gradient" color="dark" fullWidth disabled={status.loading}>
                {status.loading ? <CircularProgress size={20} color="inherit" /> : "Authorize Access"}
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </Card>
    </BasicLayout>
  );
}
